import React from "react";
import { Form,
  Message,
  Popup,
  Button,
  Icon
} from "semantic-ui-react";
import Flatpickr from "react-flatpickr";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y/m/d H:i:S",
  disableMobile: "true"
};

function General(props) {
  const { campaigns, values, valid, config } = props;
  const rules = {
    title: "required|string|no_double_quotes|no_back_slash",
    sequential_numbering_min: "integer|custom_range_requires_min_and_max",
    sequential_numbering_max: "integer|invalid_custom_number_range|exceeds_number_assignment_limit|custom_range_requires_min_and_max|max_ticket_number_exceeded",
    start_at: "required|date",
    end_at: "required|date|after:start_at",
  };
  const customMessages = {
    "after.end_at": "The End Date must come after the Start Date",
    "required.title": "Title is required",
    "required.start_at": "Start Date is required",
    "required.end_at": "End Date is required"
  };
  props.setRules(rules, customMessages);
  return (
    <Form size="large" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      <Form.Group widths="equal">
        <Form.Input
          label="Title"
          name="event.title"
          value={values.title}
          required
          error={valid.errors.has("title")}
          onChange={props.handleChange}
        />
        <Form.Field error={valid.errors.has("start_at")} required disabled={values.id > 0 && values.game_id === 4}>
          <label>Start Date</label>
          <Flatpickr
            name="event.start_at"
            value={values.start_at || ""}
            options={dateTimePicker}
            onChange={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.start_at",
                value: str
              })
            }
            onClose={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.start_at",
                value: str
              })
            }
          />
        </Form.Field>
        <Form.Field error={valid.errors.has("end_at")} required disabled={values.id > 0 && values.game_id === 4}>
          <label>End Date</label>
          <Flatpickr
            name="event.end_at"
            value={values.end_at || ""}
            options={dateTimePicker}
            onChange={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.end_at",
                value: str
              })
            }
            onClose={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.end_at",
                value: str
              })
            }
          />
        </Form.Field>
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field>
          <Popup trigger= {
              <label>
                <Icon name="help circle" color="blue" fitted /> Draw Date Text
              </label> }
            content="Here you may enter the draw date as text. It will default to prize and event information if left blank."
            inverted
            wide
          />
          <Form.Input
            name="event.draw_at_text"
            value={values.draw_at_text}
            //error={valid.errors.has("drawDateText")} //?
            onChange={props.handleChange}
          />
        </Form.Field>
      </Form.Group>

      {config.custom_number_range_enabled && <Form.Group widths="equal">
        <label>
          <Popup trigger= {
            <label>
              <Icon name="help circle" color="blue" fitted /> Custom Number Range
            </label> }
            content="Here you may enter the first and last numbers for the raffle."
            inverted
            wide
          />
        </label>
        </Form.Group>}
        {config.custom_number_range_enabled && <Form.Group widths="equal">
          <Form.Input disabled={values.id > 0}
            label="First Number"
            name="event.sequential_numbering_min"
            value={values.sequential_numbering_min}
            error={valid.errors.has("sequential_numbering_min")}
            onChange={props.handleChange}
          />
          <Form.Input disabled={values.id > 0}
            label="Last Number"
            name="event.sequential_numbering_max"
            value={values.sequential_numbering_max}
            error={valid.errors.has("sequential_numbering_max")}
            onChange={props.handleChange}
          />
      </Form.Group>}

      {config.custom_number_range_enabled && values.id == 0 &&<Form.Field>
          <label>Set custom number range as default?</label>
          <Form.Radio
            toggle
            size="large"
            label={+values.set_custom_number_range_as_default === 1 ? "Use this range for future events" : "Use this range for this event only"}
            value="0"
            name="event.set_custom_number_range_as_default"
            disabled={+values.sequential_numbering_min === 0 || +values.sequential_numbering_max === 0}
            checked={+values.set_custom_number_range_as_default === 1 && +values.sequential_numbering_min !== 0 && +values.sequential_numbering_max !== 0}
            onChange={props.handleChange}
            className="radioToggleBtn"
          />
        </Form.Field>}

      {config.raffle_num_import_enabled && <Form.Field disabled={values.id > 0}>
        <label>Import Raffle?</label>
        <Form.Radio
          toggle
          size="large"
          label={+values.is_import_raffle === 1 ? "This is an Import Raffle (Ecommerce and RSU sales will be disabled)" : "This is not an Import Raffle"}
          value="0"
          name="event.is_import_raffle"
          checked={+values.is_import_raffle === 1}
          onChange={props.handleChange}
          className="radioToggleBtn"
        />
      </Form.Field>}
      <Form.Field disabled={values.id > 0}>
        <label>Allow Prize Imports?</label>
        <Form.Radio
          toggle
          size="large"
          label={`Prize Imports ${+values.prize_imports_enabled === 1 ? 'enabled' : 'disabled'}`}
          value="0"
          name="event.prize_imports_enabled"
          checked={+values.prize_imports_enabled === 1}
          onChange={props.handleChange}
          className="radioToggleBtn"
        />
      </Form.Field>
      <Form.Field>
        <label>Live Event?</label>
        <Form.Radio
          toggle
          size="large"
          label={+values.is_test === 1 ? "This is a test event, it will not be listed in reports or winner lists" : "This is a live event"}
          value="1"
          name="event.is_test"
          checked={+values.is_test === 0}
          onChange={props.handleChange}
          className="radioToggleBtn"
        />
      </Form.Field>
      <Form.Field>
        <label>Hide Event?</label>
        <Form.Radio
          toggle
          size="large"
          label={+values.is_hidden === 1 ? "This is now a hidden event, it will not be listed in reports or winner lists" : "This event is displayed in the Event List"}
          value="1"
          name="event.is_hidden"
          checked={+values.is_hidden === 1}
          onChange={props.handleChange}
          className="radioToggleBtn"
        />
      </Form.Field>
      {campaigns && campaigns.length > 0 && <Form.Field>
        <label>Campaigns</label>
        {campaigns.map((v, k) => (
          <Form.Checkbox
            key={v.id}
            label={v.text}
            value={v.value}
            name="event.campaigns"
            checked={values.campaigns.indexOf(v.value) > -1}
            onChange={props.handleCampaigns}
          />
        ))}
      </Form.Field>
      }
      <Button
        compact
        type="button"
        primary
        size="large"
        content="Save And Continue"
        onClick={() => props.handleStep("games")}
        floated="right"
      />
    </Form>
  );
}

export default General;
